import React from 'react'
import { withIcon } from '../../withIcon'

function ArrowLeftIcon (props) {
  const {
    size = '24px',
    color = 'currentColor',
  } = props

  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox="0 0 24 24" fill="none">
      <path fillRule="evenodd" clipRule="evenodd" d="M11.0669 5.35025C11.311 5.6022 11.311 6.01069 11.0669 6.26264L6.13388 11.3548H18.625C18.9702 11.3548 19.25 11.6437 19.25 12C19.25 12.3563 18.9702 12.6452 18.625 12.6452H6.13388L11.0669 17.7373C11.311 17.9893 11.311 18.3978 11.0669 18.6497C10.8229 18.9017 10.4271 18.9017 10.1831 18.6497L4.18306 12.4562C3.93898 12.2042 3.93898 11.7957 4.18306 11.5438L10.1831 5.35025C10.4271 5.0983 10.8229 5.0983 11.0669 5.35025Z" fill={color}/>
    </svg>
  )
}

export default withIcon(ArrowLeftIcon)
